
import React from "react";
import { useTranslation } from "@emisgroup/acp-application-intl";
import "./style.scss";

interface DataEmptyProps {
  title: string;
  description: string;
  icon: React.ReactNode;
}

export const DataEmpty: React.FC<DataEmptyProps> = ({ title, description, icon }) => {
  const { t: translate } = useTranslation();
  return (
    <div className='no-data-container'>
      <div className="icon-container"  title={ translate("NoDataAvailable") } data-testid='noDataAvailable'>
        {icon}
      </div>
      <h3>{ title }</h3>
      <div className='data-error-message'>
        { description }
      </div>
    </div>
  );
};
